module.exports = __webpack_public_path__ + "static/img/press4.9511936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press4.png
// module id = NJfQ
// module chunks = 0